import { Component, OnInit } from '@angular/core';

@Component({
  selector: "app-duringcar",
  templateUrl: "./duringcar.component.html",
  styleUrls: ["./duringcar.component.css"],
})
export class DuringcarComponent implements OnInit {
  constructor() {}
  currentYear: number = new Date().getFullYear();

  ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/duringcar/duringcar.component.ts